import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.item.mail ? (_ctx.item.mail.lastReadDate ? true : false) : false)
        ? (_openBlock(), _createBlock(_component_v_tooltip, {
            key: 0,
            location: "bottom"
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_icon, _normalizeProps(_guardReactiveProps(props)), {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("$fa-envelope-open")
                ])),
                _: 2
              }, 1040)
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", null, "Contacté le " + _toDisplayString(_ctx.formatDate(_ctx.item.mail.date)) + " et lu le " + _toDisplayString(_ctx.formatDate(_ctx.item.mail.lastReadDate)), 1)
            ]),
            _: 1
          }))
        : (_ctx.item.mail ? (_ctx.item.mail.date ? true : false) : false)
          ? (_openBlock(), _createBlock(_component_v_tooltip, {
              key: 1,
              location: "bottom"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_icon, _normalizeProps(_guardReactiveProps(props)), {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("$fa-envelope")
                  ])),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, "Contacté le " + _toDisplayString(_ctx.formatDate(_ctx.item.mail.date)), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}